export const HOME_SECTION_INTENT_EVENT = "invictus:home-section-intent";

export const requestHomeSection = (id, action = "activate") => {
  if (!id || typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(HOME_SECTION_INTENT_EVENT, { detail: { id, action } }));
};